import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import Compressor from 'compressorjs';

@Injectable({
  providedIn: 'root',
})
export class FileCompressService {
  public compress(file: Blob | File, quality = 0.8): Observable<FormData> {
    return new Observable<FormData>((observer) => {
      new Compressor(file, {
        quality,
        success(result: any) {
          const formData = new FormData();
          formData.append('file', result, result.name);

          observer.next(formData);
          observer.complete();
        },
        error(err) {
          observer.error(err.message);
          observer.complete();
        },
      });
    });
  }
}
